import { ChoicesRestful } from "survey-core";
import type { SurveyModel } from "survey-core";

// Access protected members via prototype manipulation
const proto = ChoicesRestful.prototype as any;

/**
 * Overrides ChoicesRestful.sendRequest so that choicesByUrl fetches go through
 * the Axios instance stored on survey.api (which carries the base URL and auth
 * headers). Falls back to the original XHR/fetch implementation when no Axios
 * instance is available.
 */
export const registerChoicesByUrl = () => {
  const originalSendRequest = proto.sendRequest;

  proto.sendRequest = function (this: ChoicesRestful) {
    const survey = this.getSurvey(true) as SurveyModel | null;
    const api = survey?.api;

    if (!api) {
      originalSendRequest.call(this);
      return;
    }

    (this as any).beforeSendRequest();

    const loadingObjHash = (this as any).objHash;

    api
      .get(this.processedUrl)
      .then((response) => {
        (this as any).beforeLoadRequest();
        this.onLoad(response.data, loadingObjHash);
      })
      .catch((error) => {
        (this as any).beforeLoadRequest();
        (this as any).onError(error.message, error.response?.data ?? "");
      });
  };
};
